/** One host item on the SDMS sheet's right-click menu (SdmsUniverSheet `contextMenuItems`). OG's SDMS context menu
 *  adds "Apply Dilution Rule" (SpreadsheetEntryController :2124); user request 2026-10-22. */
export interface SdmsContextMenuItem {
  /** Stable id — also the Univer command id the click runs. */
  id: string;
  title: string;
  run: () => void;
}

type FMenuApi = { createMenu?: (m: { id: string; title: string; tooltip?: string; order?: number; action: () => void }) =>
  { appendTo?: (path: string) => void } };

/** Adds the host's items to the cell right-click menu (Univer facade `createMenu().appendTo('contextMenu.others')`).
 *  Best-effort: a facade without `createMenu` simply shows Univer's own menu. Each click runs the item's LATEST `run`
 *  (read through `current`), so the host can pass a fresh closure every render. */
export function addSdmsContextMenuItems(api: unknown, items: readonly SdmsContextMenuItem[],
  current: () => readonly SdmsContextMenuItem[] | undefined): void {
  const f = api as FMenuApi;
  if (!f.createMenu) return;
  items.forEach((it, order) => {
    f.createMenu!({
      id: it.id, title: it.title, tooltip: it.title, order: 100 + order,
      action: () => (current()?.find(x => x.id === it.id) ?? it).run(),
    }).appendTo?.('contextMenu.others');
  });
}
